import { Kitchen } from '@rta/rta-blueprint-library';

/**
 * Viewport rotation (degrees) that presents the overhead view square-on.
 *
 * A kitchen of one island is drawn as that island sees itself, so a corner stand -- which sits
 * at 45 in world space like every corner does inside an L or U -- reads with its front face
 * horizontal instead of as a diamond. Adding a second island makes the kitchen a normal
 * multi-island layout, whose runs are already axis-aligned, so the rotation returns to 0.
 *
 * @param kitchen kitchen being displayed, or null
 * @returns rotation in degrees to apply to the overhead viewport
 */
export const getOverheadViewRotation = (kitchen: Kitchen | null): number => {
	const islands = kitchen?.design?.islands ?? null;
	if (!islands || islands.length !== 1) return 0;

	const defaultIsland = islands.getDefaultIsland();
	return defaultIsland ? -defaultIsland.axis.y : 0;
};
